module.exports = __webpack_public_path__ + "img/menu3.a99e8466.png";